module.exports = __webpack_public_path__ + "static/media/产品介绍3.d22d5d90.png";